var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        {
          staticClass: "station-header",
          attrs: { "body-style": { padding: "14px" } },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c("el-page-header", { attrs: { content: "排班页面" } }, [
                    _c(
                      "div",
                      {
                        attrs: { slot: "title" },
                        on: { click: _vm.backFn },
                        slot: "title",
                      },
                      [
                        _c("i", { staticClass: "el-icon-arrow-left" }),
                        _vm._v("\n            返回\n          "),
                      ]
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-card",
        { staticClass: "card-box mt14" },
        [
          _c(
            "div",
            { staticClass: "head" },
            [
              _c(
                "el-form",
                { staticClass: "from-s form-box", attrs: { inline: true } },
                [
                  _c(
                    "el-form-item",
                    { staticClass: "select-bar el-input--small" },
                    [
                      _c(
                        "el-input",
                        {
                          staticClass: "mr14",
                          staticStyle: { width: "260px" },
                          attrs: {
                            size: "small",
                            placeholder: "请输入员工姓名",
                            clearable: "",
                          },
                          on: { change: _vm.getList },
                          model: {
                            value: _vm.where.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.where, "name", $$v)
                            },
                            expression: "where.name",
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "el-input__icon el-icon-search",
                            attrs: { slot: "prefix" },
                            slot: "prefix",
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { staticClass: "select-bar" },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "150px" },
                        attrs: {
                          size: "small",
                          type: "month",
                          "picker-options": _vm.pickerOptions,
                          placeholder: "选择月",
                        },
                        on: { change: _vm.getList },
                        model: {
                          value: _vm.where.date,
                          callback: function ($$v) {
                            _vm.$set(_vm.where, "date", $$v)
                          },
                          expression: "where.date",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "mt10 form-box",
              attrs: { "label-width": "90px" },
            },
            [
              _c("el-form-item", { staticClass: "h32" }, [
                _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                  _vm._v("考勤班次："),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "flex-box" },
                  [
                    [
                      _c(
                        "div",
                        { staticClass: "shift-tag" },
                        [
                          _vm._l(_vm.shiftsList, function (item, index) {
                            return _c("div", { key: index }, [
                              item.id !== 0 && item.times.length > 0
                                ? _c("div", [
                                    _c("span", {
                                      staticClass: "fang",
                                      style: { backgroundColor: item.color },
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "mr10" }, [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(item.name) +
                                          "\n                    " +
                                          _vm._s(
                                            item.times[0].first_day_after == 0
                                              ? "当日"
                                              : "次日"
                                          ) +
                                          " " +
                                          _vm._s(item.times[0].work_hours) +
                                          " -\n                    " +
                                          _vm._s(
                                            item.times[0].second_day_after == 0
                                              ? "当日"
                                              : "次日"
                                          ) +
                                          _vm._s(item.times[0].off_hours) +
                                          "\n                    "
                                      ),
                                      item.times.length > 1
                                        ? _c("span", [
                                            _vm._v(
                                              "、 " +
                                                _vm._s(
                                                  item.times[1]
                                                    .first_day_after == 0
                                                    ? "当日"
                                                    : "次日"
                                                ) +
                                                " " +
                                                _vm._s(
                                                  item.times[1].work_hours
                                                ) +
                                                " -\n                      " +
                                                _vm._s(
                                                  item.times[1]
                                                    .second_day_after == 0
                                                    ? "当日"
                                                    : "次日"
                                                ) +
                                                _vm._s(
                                                  item.times[1].off_hours
                                                ) +
                                                "\n                    "
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]),
                                  ])
                                : _vm._e(),
                            ])
                          }),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "fang",
                            staticStyle: { backgroundcolor: "#cccccc" },
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("休息")]),
                        ],
                        2
                      ),
                    ],
                  ],
                  2
                ),
              ]),
              _vm._v(" "),
              _c("el-form-item", { staticClass: "mb0" }, [
                _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                  _vm._v("排班周期："),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "flex" }, [
                  _c(
                    "div",
                    { staticClass: "flex-box" },
                    [
                      _vm._l(_vm.cycleList, function (item, index4) {
                        return [
                          item.id !== 0
                            ? _c("div", { key: index4, staticClass: "cycle" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(item.name) +
                                    _vm._s(
                                      _vm.cycleList.length > 2 ? "、" : ""
                                    ) +
                                    "\n              "
                                ),
                              ])
                            : _vm._e(),
                        ]
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "addText",
                          on: { click: _vm.addCycleFn },
                        },
                        [_vm._v("添加")]
                      ),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "tips" }, [
                    _vm._v(
                      "未排班时，系统根据排休日历配置判断是否上班，若上班按照默认班次进行考勤"
                    ),
                  ]),
                ]),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                border: "",
                "cell-style": _vm.cellStyle,
              },
            },
            [
              _c("el-table-column", {
                staticStyle: { "background-color": "#fff" },
                attrs: {
                  prop: "name",
                  label: "姓名",
                  width: "140",
                  fixed: "left",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-popover",
                          {
                            ref: "row" + scope.$index,
                            attrs: {
                              placement: "bottom",
                              width: "238px",
                              trigger: "click",
                            },
                          },
                          [
                            _c(
                              "div",
                              [
                                _c(
                                  "el-tabs",
                                  {
                                    model: {
                                      value: _vm.activeName,
                                      callback: function ($$v) {
                                        _vm.activeName = $$v
                                      },
                                      expression: "activeName",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-tab-pane",
                                      {
                                        attrs: {
                                          label: "按班次排班",
                                          name: "1",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "shiftBox" },
                                          _vm._l(
                                            _vm.shiftsList,
                                            function (item, index2) {
                                              return _c(
                                                "div",
                                                {
                                                  key: index2,
                                                  staticClass: "box",
                                                  class:
                                                    item.id == 0 ? "empty" : "",
                                                  style: {
                                                    backgroundColor: item.color,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.clickName(
                                                        scope,
                                                        item
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(item.name) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-tab-pane",
                                      {
                                        attrs: {
                                          label: "按周期排班",
                                          name: "2",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "shiftBox" },
                                          _vm._l(
                                            _vm.cycleList,
                                            function (item, cycle1) {
                                              return _c(
                                                "div",
                                                {
                                                  key: cycle1,
                                                  staticClass: "box add-line",
                                                  class:
                                                    item.id == 0 ? "empty" : "",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.clickCycle(
                                                        1,
                                                        scope,
                                                        item
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(item.name) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                attrs: { slot: "reference" },
                                slot: "reference",
                              },
                              [
                                _c(
                                  "el-tooltip",
                                  {
                                    staticClass: "item",
                                    attrs: {
                                      effect: "dark",
                                      content: "点击选中整行",
                                      placement: "top",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "nameFn",
                                        on: {
                                          click: function ($event) {
                                            return _vm.clickRowIndex(
                                              scope.row.name
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(scope.row.name) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _vm._l(_vm.colData, function (item, index1) {
                return _c("el-table-column", {
                  key: index1,
                  attrs: { prop: item.prop },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "header",
                        fn: function () {
                          return [
                            _c(
                              "el-popover",
                              {
                                ref: "column" + index1,
                                refInFor: true,
                                attrs: {
                                  placement: "right",
                                  width: "238px",
                                  trigger: "click",
                                },
                              },
                              [
                                _vm.sameDay <= index1
                                  ? _c(
                                      "el-tabs",
                                      {
                                        model: {
                                          value: _vm.activeName1,
                                          callback: function ($$v) {
                                            _vm.activeName1 = $$v
                                          },
                                          expression: "activeName1",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-tab-pane",
                                          {
                                            attrs: {
                                              label: "按班次排班",
                                              name: "1",
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "shiftBox" },
                                              _vm._l(
                                                _vm.shiftsList,
                                                function (item, index3) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: index3,
                                                      staticClass: "box",
                                                      class:
                                                        item.id == 0
                                                          ? "empty"
                                                          : "",
                                                      style: {
                                                        backgroundColor:
                                                          item.color,
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.headerClick(
                                                            index1,
                                                            item
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(item.name) +
                                                          "\n                  "
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-tab-pane",
                                          {
                                            attrs: {
                                              label: "按周期排班",
                                              name: "2",
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "shiftBox" },
                                              _vm._l(
                                                _vm.cycleList,
                                                function (item, cycle1) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: cycle1,
                                                      staticClass:
                                                        "box add-line",
                                                      class:
                                                        item.id == 0
                                                          ? "empty"
                                                          : "",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.clickCycle(
                                                            2,
                                                            index1,
                                                            item
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(item.name) +
                                                          "\n                  "
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _c("div", [_vm._v("历史日期无法排班")]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    class: item.is_rest == 1 ? "addDate" : "",
                                    attrs: { slot: "reference" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.clickColumnIndex(index1)
                                      },
                                    },
                                    slot: "reference",
                                  },
                                  [
                                    _c(
                                      "el-tooltip",
                                      {
                                        staticClass: "item",
                                        attrs: {
                                          effect: "dark",
                                          content: "点击选中整列",
                                          placement: "top",
                                        },
                                      },
                                      [
                                        _c("div", { staticClass: "date" }, [
                                          _c("div", { staticClass: "day" }, [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$moment(item.date)
                                                  .format("D")
                                              )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "week" }, [
                                            _vm._v(
                                              _vm._s(_vm.getWeek(item.date))
                                            ),
                                          ]),
                                        ]),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-popover",
                              {
                                ref: "pop" + index1,
                                refInFor: true,
                                attrs: {
                                  placement: "bottom",
                                  width: "238px",
                                  trigger: "click",
                                },
                              },
                              [
                                _vm.sameDay <= index1
                                  ? _c(
                                      "el-tabs",
                                      {
                                        model: {
                                          value: _vm.activeName2,
                                          callback: function ($$v) {
                                            _vm.activeName2 = $$v
                                          },
                                          expression: "activeName2",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-tab-pane",
                                          {
                                            attrs: {
                                              label: "按班次排班",
                                              name: "1",
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "shiftBox" },
                                              _vm._l(
                                                _vm.shiftsList,
                                                function (item, index2) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: index2,
                                                      staticClass: "box",
                                                      class:
                                                        item.id == 0
                                                          ? "empty"
                                                          : "",
                                                      style: {
                                                        backgroundColor:
                                                          item.color,
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.clickFn(
                                                            scope,
                                                            index1,
                                                            item
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(item.name) +
                                                          "\n                  "
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-tab-pane",
                                          {
                                            attrs: {
                                              label: "按周期排班",
                                              name: "2",
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "shiftBox" },
                                              _vm._l(
                                                _vm.cycleList,
                                                function (item, cycle1) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: cycle1,
                                                      staticClass:
                                                        "box add-line",
                                                      class:
                                                        item.id == 0
                                                          ? "empty"
                                                          : "",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.clickCycle(
                                                            3,
                                                            scope,
                                                            item,
                                                            index1
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(item.name) +
                                                          "\n                  "
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _c("div", [_vm._v("历史日期无法排班")]),
                                _vm._v(" "),
                                !scope.row.counts[index1]
                                  ? _c("div", {
                                      staticClass: "btn",
                                      attrs: { slot: "reference" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.cellFn(scope, index1)
                                        },
                                      },
                                      slot: "reference",
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.counts[index1]
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "btn1",
                                        style: {
                                          backgroundColor:
                                            scope.row.counts[index1].color,
                                        },
                                        attrs: { slot: "reference" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.cellFn(scope, index1)
                                          },
                                        },
                                        slot: "reference",
                                      },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              scope.row.counts[index1].name &&
                                                scope.row.counts[index1].name
                                                  .length > 4
                                                ? scope.row.counts[
                                                    index1
                                                  ].name.substring(0, 4)
                                                : scope.row.counts[index1].name
                                            ) +
                                            "\n            "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                })
              }),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "cr-bottom-button btn-shadow" },
        [
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.backFn } },
            [_vm._v("取消")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "primary" },
              on: { click: _vm.submit },
            },
            [_vm._v("保存")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("add-cycle", {
        ref: "addCycle",
        attrs: { group_id: _vm.id },
        on: { cycleList: _vm.getCycleList },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }